import { connect } from 'react-redux';
import { userLogin } from 'redux/actions/layoutActions';
import Form from './Form';

const mapStateToProps = ({ layout }) => {
    const { admin, locale, userToken, reseller } = layout;
    return { admin, locale, userToken, reseller };
};

const mapDispatchToProps = { userLogin };

export default connect(mapStateToProps, mapDispatchToProps)(Form);
